import { ScanSummaryComponent } from './scan-summary.component';

export default angular
  .module('sfMobile.components.scan-summary', [
    'sfMobile.constants.question-product',
  ])
  .component('sfScanSummary', ScanSummaryComponent).name;
